import { firestore } from '@/firebase'

const classOverridesByDate = firestore.collection('class-overrides-by-date')

export {
	classOverridesByDate
}